export default __webpack_public_path__ + "static/O0241-a702a805a47295786d429ada6983fec3.png";